import AbstractCommand from "../../application/AbstractCommand";
import SkinKeyRegistry from "../../ui/SkinKeyRegistry";

export default class PromptLanguageSelectionCommand extends AbstractCommand {
    constructor(dispatcher) {
        super(dispatcher);
    }

    execute(evt) {
        this.openScreen(SkinKeyRegistry.LANGUAGE_SELECT_SCREEN_SKIN);
    }
}